import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Flex, Text, Wrap, Icon, Divider } from '@chakra-ui/react';
import { ReactComponent as IconArrow } from 'assets/svg/arrowWest.svg';
import { DelayAnimation } from 'shared/DelayAnimation';
import { Progress } from './components';

export const NewScheduleHeader = () => {
  const navigate = useNavigate();

  const handleNavigateNewSchecule = () => {
    navigate('/agendamentos');
  };

  return (
    <DelayAnimation>
      <Box px={{ base: '16px', md: '32px' }} flex={1} minH="full" fontSize="xl">
        <Box position="sticky" top="0">
          <Flex>
            <Wrap align="center">
              <Button
                bg="white"
                rounded="full"
                variant="unstyled"
                _hover={{ bg: '#ccc' }}
                display="flex"
                alignItems="center"
                onClick={handleNavigateNewSchecule}
              >
                <Icon as={IconArrow} />
              </Button>
              <Text fontSize="18px" color="GrayText">
                Novo Agendamento de Manutenção
              </Text>
            </Wrap>
          </Flex>

          <Progress />

          <Divider
            borderWidth="1px"
            borderColor="gray.100"
            opacity="0.2"
            orientation="horizontal"
            mt="22px"
          />
        </Box>
      </Box>
    </DelayAnimation>
  );
};
